import { LinearProgress } from "@material-ui/core";
import React from "react";
import StackTrace from "stacktrace-js";

export default class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { error: null, errorInfo: null, settings: null, sending: true };
    }

    componentDidCatch(error, errorInfo) {
        // Catch errors in any components below and re-render with error message
        this.setState({
            error: error,
            errorInfo: errorInfo,
            settings: window?.settings ? window.settings : null,
        });
        // You can also log error messages to an error reporting service here

        const API_BASE = window?.debug ? "http://localhost:62027/api/" : "/api/";

        try {
            
            fetch(API_BASE + "isalive/ping", {
                method: "GET", // *GET, POST, PUT, DELETE, etc.
            })
                .then(async (response) => {
                    if (response.status >= 200 && response.status <= 300) {
                        
                        // );
                        try {
                            // want to store reponse in global variable, to avoid react or redux incase of error.
                            let json = await response.json();
                            window.settings = json;
                            this.setState({
                                ...this.state,
                                settings: json,
                            });
                        } catch {
                            
                        }
                    } else {
                        
                        throw false;
                    }
                })
                .catch((e) => {
                    
                    window.settings = null;
                });
        } catch (err_ex) {
            console.error(err_ex);
        }

        try {
            StackTrace.fromError(error).then((err) => {
                

                let template =
                    `<h2 style="color: #2e6c80;"><span style="color: #000080;">` +
                    (window.LYSAGHT ? "LLD" : "CDS") +
                    ` Front End Error Report</span></h2>
<p>This is an automated Error Report</p>
<table style="border-collapse: collapse; width: 100%" border="1" cellpadding="5px">
<tbody>
<tr style="height: 16px;">
<td style="width: 160px; font-size: 10pt; font-weight:600; background-color: rgba(221, 229, 236, 0.86);">USER NAME</td>
<td style="font-size: 10pt;">$$_USERNAME_$$</td>
</tr>
<tr style="height: 16px;">
<td style="width: 160px; font-size: 10pt; font-weight:600; background-color: rgba(221, 229, 236, 0.86);">JOB LOADED</td>
<td style="font-size: 10pt;">$$_JOB_ID_$$</td>
</tr>
<tr style="height: 16px;">
<td style="width: 160px; font-size: 10pt; font-weight:600; background-color: rgba(221, 229, 236, 0.86);">ERROR INFO</td>
<td style="font-size: 10pt;">$$_ERROR_INFO_$$</td>
</tr>
<tr style="height: 16px;">
<td style="width: 160px; font-size: 10pt; font-weight:600; background-color: rgba(221, 229, 236, 0.86);">CDS Token</td>
<td style="font-size: 10pt;">$$_CDS_TOKEN_$$</td>
</tr>
</tbody>
</table>
<p><span style="color: #999999;"><em>this email was sent from a no-reply email address, however this email has been CC'd to the requester, so you may "Reply All' to communicate directly via email with the requester.</em></span></p>`;

                let html = template;

                let user_token = getCookie("CDS_token");
                let user_SFusername = getCookie("SF_user");

                let job_id = "UNKNOWN";
                if (window?.job?.id) job_id = window?.job?.id;

                html = html.replace("$$_USERNAME_$$", user_SFusername);
                html = html.replace("$$_JOB_ID_$$", job_id);
                html = html.replace("$$_ERROR_INFO_$$", errorInfo.componentStack + "<br />" + err);
                html = html.replace("$$_CDS_TOKEN_$$", user_token);

                fetch(API_BASE + "Message/", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        // FromEmail: config.region.support_email,
                        //FromEmail: "no_reply@qikquotecentenary.com",
                        FromEmail: window.LYSAGHT ? "no_reply@lysaght.com" : "no_reply@qikquotecentenary.com",
                        FromName: window.LYSAGHT
                            ? "Lysaght Living Designer (No Reply)"
                            : "Centenary Design Suite (No Reply)",
                        Subject: window.LYSAGHT
                            ? "LLD Front End Error Report"
                            : window.FIELDERS
                            ? "CDS Front End Error Report"
                            : "Front End Error Report",
                        TextPart: errorInfo.componentStack,
                        HtmlPart: html,
                        To: "centsupport@qikquotecentenary.com",
                        CC: "bbcsoftwaresupport@bluescopesteel.com",
                        job: window?.job,
                    }),
                })
                    .then(async (response) => {
                        if (response.status >= 200 && response.status <= 300) {
                            this.setState({
                                sending: "sent",
                            });
                        } else {
                            this.setState({
                                sending: false,
                            });
                        }
                    })
                    .catch((e) => {
                        this.setState({
                            sending: false,
                        });
                    });
            });
        } catch (err_ex) {
            console.error(err_ex);
        }
    }

    render() {
        if (this.state.errorInfo) {
            // Error path

            let error_message = "";
            if (this.state.settings?.ErrorMessage) error_message = this.state.settings?.ErrorMessage;
            else if (window?.settings?.ErrorMessage) error_message = window?.settings?.ErrorMessage;

            return (
                <div>
                    <div
                        style={{
                            color: "#fff",
                            backgroundColor: window.LYSAGHT ? "#066CB6" : "#192E61",
                            boxShadow:
                                "0px 2px 4px -1px rgb(0 0 0 / 20%), 0px 4px 5px 0px rgb(0 0 0 / 14%), 0px 1px 10px 0px rgb(0 0 0 / 12%)",
                            height: "120px",
                            textAlign: "center",
                        }}
                    >
                        <img
                            src={
                                window.LYSAGHT
                                    ? "/app/images/logo-lysaghtliving-white.png"
                                    : window.FIELDERS
                                    ? "/app/images/logo-design-suite.svg"
                                    : ""
                            }
                            style={{
                                maxHeight: "40px",
                                padding: "20px",
                                marginTop: "20px",
                            }}
                        ></img>
                    </div>
                    <div
                        style={{
                            textAlign: "center",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                        }}
                    >
                        <h2>Apologies, something went wrong.</h2>
                        {this.state.sending === true && (
                            <>
                                <h3
                                    style={{
                                        marginTop: "0px",
                                    }}
                                >
                                    ... we will attempt to send an error report to our team.
                                </h3>
                                <LinearProgress style={{ width: "60%" }} />
                            </>
                        )}
                        {this.state.sending === "sent" && (
                            <h3
                                style={{
                                    marginTop: "0px",
                                }}
                            >
                                Error report successfully sent to our team.
                            </h3>
                        )}
                        {!this.state.sending && (
                            <h3
                                style={{
                                    marginTop: "0px",
                                }}
                            >
                                Error report could not be sent to our team.
                            </h3>
                        )}
                        {error_message && (
                            <div
                                style={{
                                    padding: "20px",
                                    margin: "20px",
                                    boxShadow: "6px 6px 8px #88888861",
                                    borderRadius: "7px",
                                    backgroundColor: "#ffffc6",
                                    width: "400px",
                                    maxWidth: "75%",
                                }}
                            >
                                {error_message}
                            </div>
                        )}
                        <details style={{ whiteSpace: "pre-wrap" }}>
                            {this.state.error && this.state.error.toString()}
                        </details>
                    </div>
                </div>
            );
        }
        // Normally, just render children
        return this.props.children;
    }
}

export const getCookie = (name) => {
    return document.cookie.split("; ").reduce((r, v) => {
        const parts = v.split("=");
        return parts[0] === name ? decodeURIComponent(parts[1]) : r;
    }, "");
};
